import PayOverTimeSuccess from 'features/payOverTime/screens/payments/PayOverTimeSuccess/PayOverTimeSuccess';
import React from 'react';

export default function PayOverTimeConfirmPaymentScreen() {
  return <PayOverTimeSuccess />;
}
